import React from 'react'
import {
  CFImage,
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { locationMap, mobileMap } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect w="100%" selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView w="100%">
          <MobileScreen>
            <CFLink
              target="_blank"
              href="https://maps.app.goo.gl/NBNj7J1aAEnaqRc56"
            >
              <CFImage
                maxWidth="100%"
                src={mobileMap}
                w="100%"
                alt="Ohana Poke Map"
              />
            </CFLink>
          </MobileScreen>
          <DefaultScreen m="0 auto" w="100%">
            <CFLink
              target="_blank"
              w="100%"
              m="0 auto"
              href="https://maps.app.goo.gl/NBNj7J1aAEnaqRc56"
            >
              <CFImage
                style="display: block;"
                src={locationMap}
                w="100%"
                alt="Ohana Poke Kitchen Map"
              />
            </CFLink>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
